import React, { useState } from 'react';
import MainContent from '../../../components/MainContent';
import PageContainer from '../../../components/PageContainer';
import MetricSection from '../../../components/Gym/MetricSection';
import WeeklyRevenue from '../../../components/Gym/WeeklyRevenue';
import NewGymSession from '../../../components/Gym/NewGymSession';
import GymActivity from '../../../components/Gym/GymActivity';
import PopularClasses from '../../../components/Gym/PopularClasses';
import TrainerList from '../../../components/Gym/TrainerList';
import AlertNewSession from '../../../components/Gym/AlertNewSession';
import RegisterNewCustomerModal from '../../../components/Gym/RegisterNewCustomerModal';
import MembershipPaymentModal from '../../../components/Gym/MembershipPaymentModal';
import MemberFinder from '../../../components/Gym/MemberFinder';
import FitnessPanel from '../../../components/Gym/FitnessPanel';
import { useTheme } from '../../../DataStore/ThemeContext';
import GymAdmission from '../../../components/Gym/GymAdmission';
import ajaxGym from '../../../util/remote/ajaxGym';
import { useGym } from '../../../DataStore/Gym/GymContext';
import PageTitle from '../../../components/Common/PageTitle/PageTitle';
import NewTrainer from '../../../components/Gym/NewTrainer';
import TrainerCommissionBalances from '../../../components/Gym/TrainerCommissionBalances';
import PayCommissionModal from '../../../components/Gym/PayCommissionModal';

const GymDesk = () => {
  const [showStartSession, setShowStartSession] = useState(false);
  const [showRegisterNewCustomer, setShowRegisterNewCustomer] = useState(false);
  const [showMembershipPayment, setShowMembershipPayment] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [trainerInfo, setTrainerInfo] = useState(null);
  const [showMemberFinder, setShowMemberFinder] = useState(false);
  const { setSweetDialogInfo} = useTheme();
  const [showGymAdmission, setShowGymAdmission] = useState(false);
  const {getDailySessionActivity} = useGym();
  const [showNewTrainer, setShowNewTrainer] = useState(false);
  const [showPayCommission, setShowPayCommission] = useState(false);
  

  const handleNewSession = (action, member) =>{
    setCustomerInfo(member);
    setShowStartSession(false);
    switch (action) {
      case "start_session":
        setShowGymAdmission(true);
        break;
      case "end_session":
        handeEndGymSession(member.id);
        break;
      case "register":
        setShowRegisterNewCustomer(true);
        break;
      case "renew":
        console.log("Renewing membership...");
        break;
      case "upgrade":
        console.log("Upgrading membership...");
        break;
      case "cancel":
        console.log("Cancelling membership...");
        break;
      default:
        console.log("Unknown action");
    }
  }

  const prepareMembershipPayment = (customer) => {
    setCustomerInfo(customer);
    setShowMembershipPayment(true);
  }

  const handeEndGymSession = async(memberId) => {
    const server_response = await ajaxGym.endGymSession(memberId);
    if (server_response.status === "OK") {
      setSweetDialogInfo(server_response.message, customerInfo.full_name + " has been successfully checked out");
      getDailySessionActivity();
    }else{
      getDailySessionActivity();
    }
  }

  const handlePayCommission = (trainer) => {
    setTrainerInfo(trainer);
    setShowPayCommission(true);
  }


  return (
    <>
    <PageContainer>
      <MainContent>
        {/* Main Header */}
        <PageTitle
                    title="Gym Desk"
                    description="Summary of the gym activities and metrics."
                    iconClass="fa fa-dumbbell"
                    sticky={true}/>

        <div className="row mb-2 small-gutters">
          {/* Left Side: Title and Buttons */}
          <FitnessPanel
              setShowRegisterNewCustomer={setShowRegisterNewCustomer}
              setShowMemberFinder={setShowMemberFinder}
            />

          {/* Right Side: 4 Metric Cards */}
          <div className="col-lg-5">
           <MetricSection />
          </div>
          <div className="col-lg-3">
            <WeeklyRevenue />
          </div>
          
        </div>
        <div className="row mb-0 small-gutters">
            <div className="col-lg-4">
                <NewGymSession
                  handleStart = {() => setShowStartSession(true)}
                />
            </div>
            <div className="col-lg-3">
                <GymActivity />
            </div>
            <div className="col-lg-3">
              <TrainerCommissionBalances onPay={handlePayCommission} />
            </div>
            <div className="col-lg-2">
                <PopularClasses />
            </div>
        </div>

        <div className="row mb-0 small-gutters">
          <div className="col-12">
            <TrainerList onCreate = {()=>setShowNewTrainer(true)}/> 
          </div>
        </div>


        
      </MainContent>
    </PageContainer>
    <AlertNewSession
            show={showStartSession}
            onClose={() => setShowStartSession(false)}
            onConfirm={handleNewSession}
        />

    <RegisterNewCustomerModal
      show={showRegisterNewCustomer}
      onClose={() => setShowRegisterNewCustomer(false)}
      onComplete={prepareMembershipPayment}
    />

    <MembershipPaymentModal
      show={showMembershipPayment}
      onClose={() => setShowMembershipPayment(false)}
      customer = {customerInfo}
      onStartSession={() => console.log("Session started")}
    />

    <MemberFinder
      show={showMemberFinder}
      onClose={() => setShowMemberFinder(false)}
      onProceed={(memberInfo) => {
        setShowMemberFinder(false);
        prepareMembershipPayment(memberInfo);
      }}
      onRegister={(phoneNumber) => {
        setShowMemberFinder(false);
        setShowRegisterNewCustomer(true)
      }}
    />

  <GymAdmission
    show={showGymAdmission}
    onClose={() => setShowGymAdmission(false)}
    customer={customerInfo}
    onStartSession={(sessionDetails) => {
      console.log("Session Details: ", sessionDetails);
      setShowGymAdmission(false);
    }}
  />

  <NewTrainer
    show={showNewTrainer}
    onClose={() => setShowNewTrainer(false)}
    onComplete={(trainer) => {
      console.log("New Trainer: ", trainer);
      setShowNewTrainer(false);
    }}
  />

  <PayCommissionModal
    show={showPayCommission}
    onClose={() => setShowPayCommission(false)}
    trainer={trainerInfo}
    onConfirm={(response) => {
      console.log("Commission Paid: ", response);
      setShowPayCommission(false);
    }}
  />
    </>
  );
};

export default GymDesk;
